module.exports = __webpack_public_path__ + "static/media/img_howto_image.26435833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_howto_image.png
// module id = 1081
// module chunks = 0